import { TICKET_TYPE_ORDER } from '../../../constants/forecast';

export const getBSType = (data) => {
  const ticketType = data.map((item) => item.ticket_type).filter(Boolean);
  const uniqueTicketTypes = [...new Set(ticketType)];
  if (uniqueTicketTypes.length === 0) {
    return [];
  }

  return uniqueTicketTypes.sort((a, b) => {
    const indexA = TICKET_TYPE_ORDER.indexOf(a);
    const indexB = TICKET_TYPE_ORDER.indexOf(b);

    // If both are in the order list, sort by order
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    // If only a is in the order list, a comes first
    if (indexA !== -1) return -1;
    // If only b is in the order list, b comes first
    if (indexB !== -1) return 1;
    // If both are not in the order list, sort by alphabet
    return a.localeCompare(b);
  });
};
